import _ from 'underscore';
import $ from 'jquery';
import { BaseCard } from '@bingads-webui-campaign/overview-base-card';
import { helpers } from '@bingads-webui/deterministic-view';
import { getFilteredTotalsMetrics, fetchAggregatedData, allMetrics, patchMetrics } from '@bingads-webui-campaign/overview-cards-common';
import SingleMetric from './metric/index';
import template from './template.pug';
import { getDeviceOrder } from './order';

const defaultMetrics = ['Clicks', 'Impressions', 'Spend'];
const layoutSize = {
  small: 0,
  large: 1,
};
const graphLayoutBreakPoint = 100;
const smallLayoutBreakPoint = 585;

/* @this DeviceCard */
function getGraphLayoutSize() {
  if (this.$('.device-graph-legend-container').outerWidth() < graphLayoutBreakPoint) {
    return layoutSize.small;
  }
  return layoutSize.large;
}

/* @this TipsCard */
function getLayoutSize() {
  if (this.$el.closest('.card-holder__wrapper').outerWidth() < smallLayoutBreakPoint) {
    return layoutSize.small;
  }
  return layoutSize.large;
}

/* @this DeviceCard */
function reLayoutGraph() {
  const newLayoutSize = getGraphLayoutSize.call(this);

  if (this.currentGraphLayoutSize === newLayoutSize) {
    return;
  }

  if (newLayoutSize === layoutSize.small) {
    this.$('.device-graph-legend-container').addClass('small_graph');
  } else {
    this.$('.device-graph-legend-container').removeClass('small_graph');
  }

  this.currentGraphLayoutSize = newLayoutSize;
}

function isAggregatedMetric(metric) {
  return _.indexOf(['CTR', 'ConversionRate', 'RevenueOnAdSpend', 'AverageCPC', 'AveragePosition'], metric) !== -1;
}

/* @this DeviceCard */
function reLayout() {
  reLayoutGraph.call(this);

  const newLayoutSize = getLayoutSize.call(this);

  if (newLayoutSize === this.currentLayoutSize) {
    return;
  }

  if (newLayoutSize === layoutSize.small) {
    this.$el.addClass('small_layout');
  } else {
    this.$el.removeClass('small_layout');
  }

  this.currentLayoutSize = newLayoutSize;
}

/* @this DeviceCard */
function updateView() {
  const currentMetrics = this.getState().metrics;
  const { i18n } = this.deps;

  this.children = [];
  _.each(currentMetrics, (metric, index) => {
    const child = helpers.ensureChildView(this, String(index), SingleMetric, {
      metricFormatter: this.deps.metricFormatter,
      s$i18n: this.deps.s$i18n,
      i18n,
    }, {
      pick: ({ metric: picked }) => {
        const metricsWhenPick = _.clone(this.getState().metrics);

        metricsWhenPick[index] = picked;

        const { instrumentation, constants } = this.deps;

        instrumentation.logMessage(
          [constants.LOGCATEGORY.TRACE],
          constants.LOGLEVEL.INFO,
          'device-card',
          `${this.navigationLevel} level new metric picked.`
        );
        helpers.updateView(this, {
          metrics: metricsWhenPick,
        });
        this.trigger('storeCardPreference', { metrics: metricsWhenPick });
        const actionButton = this.$('.view-all-clickLink');
        if (actionButton.length > 0) {
          actionButton.focus();
        }
      },
    });

    this.children.push(child);

    helpers.updateView(child, {
      metric,
      segmentedPerformanceMetrics: this.performanceMetrics.SegmentedData,
      metrics: _.difference(allMetrics(this.permissions), currentMetrics),
      hideCurrency: this.hideCurrency,
    });
  });

  const { dateRange } = this.getState();

  if (!dateRange) {
    return;
  }

  const formatOption = {
    hideCurrency: this.hideCurrency,
  };

  this.data = _.map(getDeviceOrder({
    permissions: this.permissions,
    navigationLevel: this.navigationLevel,
    currentCampaign: this.currentCampaign,
  }), (deviceType) => {
    const { Data: segmentedData } = _.find(
      this.performanceMetrics.SegmentedData,
      ({ Key }) => Key[0].StringValue === deviceType
    ) || { Data: {} };

    let segmentedPeriodData = {};
    let segmentedChangePercentageData = {};

    if (dateRange.compared) {
      const { Data: periodData } = _.find(
        this.periodPerformanceMetrics.SegmentedData,
        ({ Key }) => Key[0].StringValue === deviceType
      ) || { Data: {} };

      segmentedPeriodData = periodData;

      const { Data: changePercentageData } = _.find(
        this.performanceMetricsChangePercentage.SegmentedData,
        ({ Key }) => Key[0].StringValue === deviceType
      ) || { Data: {} };

      segmentedChangePercentageData = changePercentageData;
    }

    const formattedData = {};
    const formattedPeriodData = {};

    _.each(currentMetrics, (metric) => {
      const { metricFormatter } = this.deps;
      const value = segmentedData[metric] || 0;
      let flexValue = 0;

      if (!isAggregatedMetric(metric) && this.performanceMetrics[metric]) {
        flexValue = Math.round((value * 10000) / this.performanceMetrics[metric]);
      }

      const formattedSegment = metricFormatter.formatMetric(metric, value, formatOption);
      const formattedHoverValue = isAggregatedMetric(metric) ? formattedSegment :
        `${formattedSegment} (${i18n.getString(
          'Dashboard_DeviceCard_Percentage_Total',
          {
            percentage: i18n.formatPercent(flexValue / 10000, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }),
          }
        )})`;

      formattedData[metric] = {};
      _.extend(formattedData[metric], {
        metric,
        value,
        formattedSegment,
        flexValue: !value ? 0 : Math.max(flexValue, 1),
        formattedHoverValue,
      });

      if (dateRange.compared) {
        const periodValue = segmentedPeriodData[metric] || 0;
        let periodFlexValue = 0;

        if (!isAggregatedMetric(metric) && this.periodPerformanceMetrics[metric]) {
          periodFlexValue = Math.round((periodValue * 10000) / this.periodPerformanceMetrics[metric]);
        }

        const formattedPeriodSegment = metricFormatter.formatMetric(
          metric,
          periodValue,
          formatOption
        );

        const formattedPeriodHoverValue = isAggregatedMetric(metric) ? formattedPeriodSegment :
          `${formattedPeriodSegment} (${i18n.getString(
            'Dashboard_DeviceCard_Percentage_Total',
            {
              percentage: i18n.formatPercent(periodFlexValue / 10000, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              }),
            }
          )})`;

        formattedPeriodData[metric] = {};
        _.extend(formattedPeriodData[metric], {
          metric,
          value: periodValue,
          changePercentage: segmentedChangePercentageData[metric],
          formattedChangePercentage: `(${metricFormatter.formatChangePercentageWithSign(segmentedChangePercentageData[metric] || 0)})`,
          formattedChange: metricFormatter.formatMetricWithSign(metric, value - periodValue),
          formattedSegment: formattedPeriodSegment,
          flexValue: !periodValue ? 0 : Math.max(periodFlexValue, 1),
          formattedHoverValue: formattedPeriodHoverValue,
        });
      }
    });
    const returnValue = { formattedData };

    if (dateRange.compared) {
      _.extend(returnValue, { formattedPeriodData });
    }
    return returnValue;
  });

  const formattedDateRange = `${i18n.formatDate(dateRange.start)} - ${i18n.formatDate(dateRange.end)}`;
  const formattedPeriodDateRange = dateRange.compared ? `${dateRange.compared.formattedStart} - ${dateRange.compared.formattedEnd}` : null;

  _.extend(this.data, {
    formattedDateRange,
    formattedPeriodDateRange,
  });
  this.loaded = true;
  this.render();
}

/* @this DeviceCard */
function loadData() {
  const {
    dateRange,
    filter,
  } = this.getState();
  const { instrumentation, constants, config } = this.deps;

  this.blockCard();
  this.willFetchData();
  fetchAggregatedData({
    entitySet: this.entitySet,
    dateRange,
    filter,
    jsdata: this.deps.jsdata,
    dateUtil: this.deps.dateUtil,
    navigationLevel: this.navigationLevel,
    getCardsConfig: this.sharedOptions.getCardsConfig,
    fetchSingleTile: this.fetchSingleTile,
    isDevice: true,
    permissions: config && config.get('Permissions'),
    dfmCacheKey: `${this.typeId}-aggregated-data`,
  }).finally(() => {
    this.unblockCard();
  }).then((data) => {
    this.hasError = false;
    if (this.removed) {
      return;
    }

    if (data.status !== null && data.status !== undefined) {
      // If we have error status. Those are already logged in ajax stub.
      // Add a trace log.
      this.hasError = true;
      updateView.call(this);
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'device-card', JSON.stringify(data));
      return;
    }

    if (!data.raw && !data.DeviceSegmentedPerformanceData) {
      this.hasError = true;
      updateView.call(this);
      instrumentation.logMessage([constants.LOGCATEGORY.ERROR], constants.LOGLEVEL.INFO, 'device-card', JSON.stringify(data));
      return;
    }

    this.hideCurrency = data.AccountsHaveDifferentCurrencies;
    this.dataFetched = true;
    this.performanceMetrics = getFilteredTotalsMetrics({
      data,
      metric: 'PerformanceMetrics',
    }) || {};

    _.defaults(this.performanceMetrics, { SegmentedData: {} });

    if (dateRange.compared) {
      this.performanceMetricsChangePercentage = getFilteredTotalsMetrics({
        data,
        metric: 'PerformanceMetricsChangePercentage',
      }) || {};

      _.defaults(this.performanceMetricsChangePercentage, { SegmentedData: {} });

      this.periodPerformanceMetrics = getFilteredTotalsMetrics({
        data,
        metric: 'PeriodPerformanceMetrics',
      }) || {};

      _.defaults(this.periodPerformanceMetrics, { SegmentedData: {} });
    }

    this.hasError = false;
    updateView.call(this);
  }).catch((response) => {
    this.dataFetched = true;
    // no need to log ajax error here.
    if (response.status === undefined) {
      instrumentation.logMessage([constants.LOGCATEGORY.ERROR], constants.LOGLEVEL.INFO, 'device-card', response.stack);
    }
    this.loaded = true;
    this.hasError = true;
    this.renderTrunk();
  });
}

/* @this DeviceCard */
function navigateToDevicesSetting() {
  if (this.navigationLevel === 'account') {
    this.deps.legacyRouter.navigateToRoute('campaign_settings', {
      setting: 'devices',
    });
  } else {
    const campaignId = this.deps.state.get('campaign_id');

    this.deps.legacyRouter.navigateToRoute('campaign_edit_settings', {
      // eslint-disable-next-line camelcase
      campaign_id: campaignId,
      setting: 'devices',
    });
  }
}

export class DeviceCard extends BaseCard {
  className() {
    return 'device-card';
  }

  initialize({
    entitySet,
    metrics,
    navigationLevel,
    dateRange,
    perfMarker,
    name,
    deps,
    sharedOptions,
    filter,
    fetchSingleTile = false,
    preexecuteFlag = false,
    typeId,
  }) {
    this.initPerfMarker({ perfMarker, name });
    this.performanceMetrics = { SegmentedData: {} };
    this.performanceMetricsChangePercentage = { SegmentedData: {} };
    this.periodPerformanceMetrics = { SegmentedData: {} };
    this.entitySet = entitySet;
    this.navigationLevel = navigationLevel;
    this.sharedOptions = sharedOptions;
    this.fetchSingleTile = fetchSingleTile;
    this.deps = deps;
    this.typeId = typeId;

    const { config } = this.deps;
    this.permissions = config && config.get('Permissions');
    this.currentCampaign = config && config.get('CurrentCampaign');
    let selectedMetrics;

    if (metrics) {
      const patchedMetrics = patchMetrics({ permissions: this.permissions, metrics });
      const availableMetrics = allMetrics(this.permissions);

      selectedMetrics = _.intersection(patchedMetrics, availableMetrics);

      if (_.size(selectedMetrics) < _.size(defaultMetrics)) {
        selectedMetrics = _.chain(selectedMetrics)
          .union(defaultMetrics)
          .uniq()
          .first(_.size(defaultMetrics))
          .value();

        _.defer(() => {
          this.trigger('storeCardPreference', { metrics: selectedMetrics });
        });
      }
    } else {
      selectedMetrics = defaultMetrics;
    }

    this.setState({
      metrics: selectedMetrics,
      dateRange,
      filter,
    });

    const loadDataFunc = preexecuteFlag ? () => {
      this.dataFetched = true;
    } : loadData;

    loadDataFunc.call(this);

    this.listenTo(this.model, 'change:dateRange', () => {
      this.fetchSingleTile = false;
      loadDataFunc.call(this);
    });

    this.listenTo(this.model, 'change:filter', () => {
      this.fetchSingleTile = false;
      loadDataFunc.call(this);
    });

    this.listenTo(this.model, 'change:metrics', () => {
      updateView.call(this);
    });

    this.onResize(() => {
      reLayout.call(this);
    });

    this.on('removed', () => {
      this.removed = true;
    });
  }

  get events() {
    return {
      'mouseenter .device-grid-bar': this.showPopup,
      'mouseleave .device-grid-bar': this.hidePopup,
      'click .view-all-clickLink': navigateToDevicesSetting.bind(this),
    };
  }

  showPopup(event) {
    const $target = $(event.currentTarget);
    const type = $target.data('type');

    $target.closest('.graph-area').addClass(`show-${type}-hover`);
  }

  hidePopup(event) {
    const $target = $(event.currentTarget);
    const type = $target.data('type');

    $target.closest('.graph-area').removeClass(`show-${type}-hover`);
  }

  renderTrunk() {
    if (this.dataFetched) {
      this.willRenderWithData();
    }
    this.currentLayoutSize = undefined;
    this.currentGraphLayoutSize = undefined;
    super.renderTrunk();
    if (this.dataFetched) {
      this.renderedWithData();
      _.defer(() => {
        reLayout.call(this);
      });
    }
  }

  get template() {
    const { metrics } = this.getState();
    const { data } = this;
    const { i18n, s$i18n } = this.deps;

    return () => template({
      isSmartShoppingCampaign: this.isSmartShoppingCampaign(),
      s$i18n,
      order: getDeviceOrder({
        permissions: this.permissions,
        navigationLevel: this.navigationLevel,
        currentCampaign: this.currentCampaign,
      }),
      metrics,
      data,
      loaded: this.loaded,
      hasError: this.hasError,
      i18n,
      isAggregatedMetric,
      navigationLevel: this.navigationLevel,
    });
  }

  setState(newState) {
    if (newState.metrics && (_.size(newState.metrics) > _.size(defaultMetrics))) {
      // Customer might have erroneous preference due to bug that is fixed.
      // Reset to default.
      // eslint-disable-next-line no-param-reassign
      newState.metrics = defaultMetrics;
      this.trigger('storeCardPreference', { metrics: newState.metrics });
    }

    super.setState(newState);
  }
}
